const checkStrengthPassword = (value) => {
  const format = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.!@#\$%\^&\*])(?=.{8,})");
  //Password must be atleast 8 characters with atleast one uppercase , lowercase and special character. 
  return (
    (value.match(/[a-z]/) || []).length > 0 &&
    (value.match(/[A-Z]/) || []).length > 0 &&
    format.test(value)
  );
};
export default checkStrengthPassword;